import { useState, useEffect } from "react";
import { isMobileScreen } from "@/utils/functions";
import Image from "@/atoms/Image";
import Para from "@/components/atoms/text/Para";
import Label from "@/atoms/text/Label";

export default function Testimonial({
  bgColor,
  image,
  content,
  name,
  company,
}) {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <section className={`bc-${bgColor} pv-10-d pv-7 ps-r testimonial`}>
      <div className="container">
        <article
          className={`pv-10-d pl-15-d pr-15-d pv-6 pl-6 pr-6 bc-white br-20`}
        >
          <Para
            className={`bold testimonial-para mb-8 ${
              !isMobile ? "ta-center" : ""
            }`}
          >
            “{content}”
          </Para>
          <div className="fx fx--c-d fx--r-d fx--ch-d fx--cv">
            {image && (
              <Image
                fileName={image.fileName}
                fileFormat="png"
                desktopWidth={image.desktopWidth}
                mobileWidth={image.mobileWidth}
                alt={image.altText}
                has2XWebp
              />
            )}
            <div className="text--sm">
              <Label size="lg" color="black" className="bold">
                {name}
              </Label>
              <Para color="black">{company}</Para>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
